"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSpacing = void 0;
var DefaultSpacing_1 = require("./DefaultSpacing");
Object.defineProperty(exports, "DefaultSpacing", { enumerable: true, get: function () { return DefaultSpacing_1.DefaultSpacing; } });
//# sourceMappingURL=index.js.map